<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      //控制视图是否显示的变量
      isRouterAlive: true, 
    };
  },
  methods: {
    reload() {
      //先关闭，
      this.isRouterAlive = false; 
      this.$nextTick(function () {
        //再打开
        this.isRouterAlive = true; 
      });
    },
  }
};
</script>

<style>
#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

  * {
    margin: 0;
    padding: 0;
  }
  .flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }

  .flex-alc {
    align-items: center;
  }

  .flex-dic {
    flex-direction: column;
  }

  .flex-item {
    flex: 1;
    min-width: 0;
  }

  .justify-between {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .justify-center {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .cmm-toolbar_main,
  .cmm-toolbar_main .el-select,
  .cmm-toolbar_main .el-input,
  .cmm-toolbar_main .el-range-editor.el-input__inner {
    margin-right: 15px;
    margin-bottom: 8px;
  }

  .cmm-toolbar_main .el-input {
    width: 120px;
  }

  .hide {
    display: none;
  }

  .show {
    display: block;
  }

  /* elementui 时间选择滚轮错位 */
  .el-time-panel__content::after {
    content: "" !important;
    top: 50% !important;
    position: absolute !important;
    margin-top: -15px !important;
    height: 32px !important;
    z-index: -1 !important;
    left: 0 !important;
    right: 0 !important;
    box-sizing: border-box !important;
    padding-top: 6px !important;
    text-align: left !important;
    border-top: 1px solid #E4E7ED !important;
    border-bottom: 1px solid #E4E7ED !important;
  }

  .el-time-spinner__list::before {
    height: 72px !important;
  }

  .icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.5em;
    float: left;
    margin-top: 0.3rem;
    fill: currentColor;
    overflow: hidden;
  }

  .svg-external-icon {
    background-color: currentColor;
    mask-size: cover!important;
    display: inline-block;  
  }

</style>



// WEBPACK FOOTER //
// src/App.vue